/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TierInputs */

const en_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tier`)
};

const es_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel`)
};

const fr_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const de_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stufe`)
};

const ja_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラン階層`)
};

const zh_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等级`)
};

const ar_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المستوى`)
};

const id_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat`)
};

const it_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello`)
};

const ru_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тариф`)
};

const pt_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano`)
};

const ko_tier = /** @type {(inputs: TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등급`)
};

/**
* | output |
* | --- |
* | "Tier" |
*
* @param {TierInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier = /** @type {((inputs?: TierInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TierInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier(inputs)
	if (locale === "es") return es_tier(inputs)
	if (locale === "fr") return fr_tier(inputs)
	if (locale === "de") return de_tier(inputs)
	if (locale === "ja") return ja_tier(inputs)
	if (locale === "zh") return zh_tier(inputs)
	if (locale === "ar") return ar_tier(inputs)
	if (locale === "id") return id_tier(inputs)
	if (locale === "it") return it_tier(inputs)
	if (locale === "ru") return ru_tier(inputs)
	if (locale === "pt") return pt_tier(inputs)
	return ko_tier(inputs)
});